import { CORPORATION } from "@/constants";

export const checkCurrentTable = ({ corporation, option, currentTable }) => {
  const isSenado = CORPORATION.SENADO === corporation;
  const isCamara = CORPORATION.CAMARA === corporation;
  const isConsulta = CORPORATION.CONSULTA === corporation;
  const isE14 = option === "E14";
  const isVotes = option === "CuentaVotos";
  const isClaim = option === "Reclamaciones";
  const isRegister = option === "register";
  if (isSenado) {
    if (isRegister) {
      currentTable.ingreso_datos_sen = true;
    }
    if (isE14) {
      currentTable.E14_sen = true;
    }
    if (isVotes) {
      currentTable.cuenta_votos_sen = true;
    }
    if (isClaim) {
      currentTable.reclamaciones_sen = true;
    }
  }

  if (isCamara) {
    if (isRegister) {
      currentTable.ingreso_datos_cam = true;
    }
    if (isE14) {
      currentTable.E14_cam = true;
    }
    if (isVotes) {
      currentTable.cuenta_votos_cam = true;
    }
    if (isClaim) {
      currentTable.reclamaciones_cam = true;
    }
    if (isRegister) {
      currentTable.ingreso_datos_cam = true;
    }
  }
  if (isConsulta) {
    if (isRegister) {
      currentTable.ingreso_datos_consulta = true;
    }
    if (isE14) {
      currentTable.E14_consulta = true;
    }
    if (isVotes) {
      currentTable.cuenta_votos_consulta = true;
    }
    if (isClaim) {
      currentTable.reclamaciones_consulta = true;
    }
  }
  return currentTable;
};
